/* istanbul ignore file */
export class LoggerTexts {
	public static PXAPI_ERROR = class {
		public static readonly ERROR_HEADER = 'An unknown error occurred in PxApi.';
	};
	public static BALANCER = class {
		public static readonly CTOR_STORAGE_NOT_PROVIDED = 'storage is not provided!';
	};
	public static CENTRAL_CFG = class {
		public static readonly CTOR_CFG_ID_CANNOT_BE_NULL = 'ConfigIdentifier cannot be null';
		public static readonly CTOR_TENANT_INFO_CANNOT_BE_NULL = 'TenantInfo cannot be null';
		public static readonly CTOR_PUSH_CFG_EMPTY = 'pushConfig empty and will be ignored.';
		public static readonly CTOR_THEMING_CFG_EMPTY = 'themingConfig empty and will be ignored.';
	};
	public static CFG_LOADER = class {
		public static readonly ERROR_HEADER = 'Loading PX-Config';
		public static readonly GET_CENTRAL_CFG_LOADING_ERROR_OCCURRED = `An error has occurred while loading the Central Configuration`;
		public static readonly GET_CENTRAL_CFG_LOADING_INVALID_CONTENT_TYPE = `Configuration response is not in JSON format`;
	};
	public static CFG_JSON_PARSER = class {
		public static readonly ERROR_HEADER = 'Parsing PX-Config JSON failed';
		public static readonly CTOR_TENANT_INFO_CANNOT_BE_NULL = 'tenantInfo cannot be null';
		public static readonly CTOR_JSON_DATA_CANNOT_BE_NULL = 'jsonData cannot be null';
		public static readonly CTOR_JSON_DATA_UNEXPECTED_ERROR = 'An unexpected error occured when parsing the configuration: ';
	};
	public static CFG_UTIL = class {
		public static readonly ERROR_HEADER = 'Config validation failed';
		public static readonly USE_API_FALSE_DEPRECATION_WARNING =
			'[DEPRECATION WARNING] PxApi - Central config: runtimeConfig.useApi should not be set to false anymore.';
		public static readonly RUNTIME_CFG_USEAPI_TRUE_THEN_DOMELEMENT_ID_NO_EFFECT =
			'Runtime config: when useApi=true domElementId will have not effect.';
		public static readonly THEMING_CFG_WRITE_TO_GLOBALS_SET_TO_FALSE_NO_EFFECT = 'Theming config: writeToGlobals=false has no effect.';
		public static readonly TIMED_PUSH_VALUE_BELOW_LIMIT_INTERVAL_TIMER_MIN =
			'Timed Push config: intervalTimerInMinutes is below the acceptable limit, please review to avoid problems.';
		public static readonly TIMED_PUSH_VALUE_BELOW_LIMIT_MIN_START_TIMER =
			'Timed Push config: minimumTimeToStartTimerInHrs is below the acceptable limit, please review to avoid problems.';
		public static readonly TIMED_PUSH_VALUE_BELOW_LIMIT_INTERVAL_INIT_PUSH =
			'Timed Push config: intervalInitialPushInDays is below the acceptable limit, please review to avoid problems.';
		public static readonly TIMED_PUSH_VALUE_BELOW_LIMIT_DEVIATION_INIT_PUSH =
			'Timed Push config: deviationInitialPushInDays is below the acceptable limit, please review to avoid problems.';
		public static readonly TIMED_PUSH_VALUE_BELOW_LIMIT_INTERVAL_NEXT_PUSH =
			'Timed Push config: intervalNextPushInDays is below the acceptable limit, please review to avoid problems.';
		public static readonly TIMED_PUSH_VALUE_BELOW_LIMIT_DEVIATION_NEXT_PUSH =
			'Timed Push config: deviationNextPushInDays is below the acceptable limit, please review to avoid problems.';
		public static readonly APP_PUSH_VALUE_BELOW_LIMIT_INTERVAL_INIT_PUSH =
			'App Push config: intervalInitialPushInDays is below the acceptable limit, please review to avoid problems.';
		public static readonly APP_PUSH_VALUE_BELOW_LIMIT_DEVIATION_INIT_PUSH =
			'App Push config: deviationInitialPushInDays is below the acceptable limit, please review to avoid problems.';
		public static readonly APP_PUSH_VALUE_BELOW_LIMIT_INTERVAL_NEXT_PUSH =
			'App Push config: intervalNextPushInDays is below the acceptable limit, please review to avoid problems.';
		public static readonly APP_PUSH_VALUE_BELOW_LIMIT_DEVIATION_NEXT_PUSH =
			'App Push config: deviationNextPushInDays is below the acceptable limit, please review to avoid problems.';
		public static readonly INIT_CFG_IDENTIFIER_INVALID_UNIT_ID = 'configIdentifier has either invalid unitId or it is missing.';
		public static readonly INIT_CFG_IDENTIFIER_INVALID_ENVIRONMENT = 'configIdentifier has either invalid environment or it is missing.';
		public static readonly INIT_CFG_IDENTIFIER_INVALID_CFG_URL = 'configIdentifier has either invalid configUrl or it is missing.';
	};
	public static CONTROLLER_PROVIDER = class {
		public static readonly INIT_TIMED_PUSH_NOT_AVAILABLE =
			'TimedPushController cannot be initialized due to invalid/insufficient timedPush configuration.';
		public static readonly INIT_INSTANT_PUSH_NOT_AVAILABLE =
			'InstantPushController cannot be initialized due to invalid/insufficient instantPush configuration.';
	};
	public static CSS_THEMING = class {
		public static readonly LOAD_CSS_MODULE_ERROR = 'CSS Theming module not loaded.';
	};
	public static TIMED_PUSH_CTRL = class {
		public static readonly INIT_INTERVAL_NOT_VALID = 'Interval for Timed Push is invalid, could not start Timed Push trigger.';
		public static readonly INIT_MIN_TIME_NOT_VALID = 'Minimum time to start timer for Timed Push is invalid, could not start Timed Push trigger.';
		public static readonly INFO_PUSH_TRIGGERED = 'Px Api: timed push was triggered.';
	};
	public static APP_PUSH_CFG = class {
		public static readonly VALID_FROM_CANNOT_BE_AFTER_VALID_TO = 'Valid-From date cannot be after Valid-to date.';
		public static readonly AREAID_CANNOT_BE_EMTPY = 'areaId cannot be empty.';
		public static readonly TRIGGERNAME_CANNOT_BE_EMTPY = 'triggerName cannot be empty.';
	};
	public static APP_PUSH_STATE = class {
		public static readonly CTOR_AREA_ID_NOT_PROVIDED = 'areaId is not provided!';
		public static readonly CTOR_TRIGGER_NAME_NOT_PROVIDED = 'triggerName is not provided!';
		public static readonly CTOR_TRIGGER_TYPE_NOT_PROVIDED = 'triggerType is not provided!';
	};
	public static INSTANT_PUSH_CFG = class {
		public static readonly VALID_FROM_CANNOT_BE_AFTER_VALID_TO = 'Valid-From date cannot be after Valid-to date.';
		public static readonly AREAID_CANNOT_BE_EMTPY = 'areaId cannot be empty.';
		public static readonly TRIGGERNAME_CANNOT_BE_EMTPY = 'triggerName cannot be empty.';
	};
	public static INIT_CONTROLLER = class {
		public static readonly ERROR_HEADER = 'Init failed.';
		public static readonly INIT_MANDATORY_PARAMS_NOT_VALID_TENANT_INFO = 'Mandatory parameter "tenantInfo" null or empty.';
		public static readonly INIT_MANDATORY_PARAMS_NOT_VALID_TENANT_ID = 'Mandatory parameter "tenantInfo.tenantId" null or empty.';
		public static readonly INIT_MANDATORY_PARAMS_NOT_VALID_TENANT_ROLE = 'Mandatory parameter "tenantRole.tenantRole" null or empty.';
		public static readonly INIT_MANDATORY_PARAMS_VALID = 'Mandatory init parameters are validated successfully.';
		public static readonly INIT_CFG_ID_OR_CFG_JSON_NEED_TO_BE_PROVIDED = 'Either "configIdentifier" or "configJson" must be provided.';
		public static readonly INIT_BOTH_CFG_IDENTIFIER_CFG_JSON_NOT_POSSIBLE = 'Please provide either configIdentifier or configJson, but not both.';

		public static readonly INIT_QUALTRICS_URI_CANNOT_BE_REACHED =
			'Qualtrics Uri cannot be reached. Please make sure to pass the correct Uri. Additionally, make sure that there is no Ad Blocker active in your browser.';
		public static readonly INIT_QUALTRICS_LOADING_FAILED = 'QSI API did not load successfully.';
		public static readonly RENDER_QUALTRICS_SCRIPT_FAILED = 'Qualtrics "Script" could not be rendered.';
		public static readonly INIT_CFG_LOAD_FAILED =
			'Could not load Config due to incorrect combination of Init mode with configIdentifier or configJson.';
		public static readonly INIT_LOADING_MANUAL_CFG_FAILED = 'Loading of manual config failed.';
		public static readonly SURVEY_INVITATION_DIALOG_CALLBACK_NOT_PROVIDED: 'Survey Invitation dialog callback method is not provided.';
		public static readonly APP_PUSH_SCOPE_SET_INCONSISTENT =
			'scopeSet "appPush" is configured in configuration but same could not be validated successfully during the runtime. Application triggered Push functionality will not be enabled!';
		public static readonly TIMED_PUSH_SCOPE_SET_INCONSISTENT =
			'scopeSet "timedPush" is configured in configuration but same could not be validated successfully during the runtime. Time Controlled Push functionality will not be enabled!';
		public static readonly INSTANT_PUSH_SCOPE_SET_INCONSISTENT =
			'scopeSet "instantPush" is configured in configuration but same could not be validated successfully during the runtime. Instant Push functionality will not be enabled!';
		public static readonly INIT_PUSH_FEATURES_NOT_POSSIBLE: 'Could not initialize the Push features since the Survey Invitation dialog callback method is not provided.';
	};
	public static PRESENTATION_CTRL = class {
		public static readonly CTOR_STORAGE_SRVC_NOT_PROVIDED = 'StorageService is not provided!';
		public static readonly CTOR_CENTRAL_CFG_NOT_PROVIDED = 'CentralConfig is not provided!';
		public static readonly CTOR_QUALTRICS_BRIDGE_NOT_PROVIDED = 'QualtricsBridge is not provided!';
		public static readonly CTOR_CNTXT_DATA_CTRL_NOT_PROVIDED = 'ContextDataController is not provided!';
		public static readonly CTOR_INVITATION_CALLBACK_NOT_PROVIDED = 'surveyInvitationDialogCallback is not provided!';
		public static readonly APP_PUSH_STATE_NOT_UPDATED = 'App Push state could not be updated.';
	};

	public static PUSH_HANDLER = class {
		public static readonly INSTANT_PUSH_STATE_NEXT_DATE_NOT_UPDATED = 'Instant Push state (next date) could not be updated.';
		public static readonly INSTANT_PUSH_STATE_SNOOZE_DATE_NOT_UPDATED = 'Instant Push state (snooze date) could not be updated.';
	};

	public static PUSH_CFG = class {
		public static readonly CTOR_STARTUPCFG_CANNOT_BE_NULL = 'startupConfig cannot be null';
		public static readonly INACTIVE_APP_PUSH_CFG = 'Requested Application-triggered Push Configuration is expired or it is not enabled!';
		public static readonly APP_PUSH_CFG_NOT_FOUND =
			'Requested Application-triggered Push Configuration is not found! It may not be available in the PX Configuration?';
		public static readonly INACTIVE_INSTANT_PUSH_CFG = 'Requested Instant Push Configuration is expired or it is not enabled!';
		public static readonly INSTANT_PUSH_CFG_NOT_FOUND =
			'Requested Instant Push Configuration is not found! It may not be available in the PX Configuration?';
	};
	public static PX_API = class {
		public static readonly FEATURES_COULD_NOT_BE_INITIALIZED = 'Features could not be initialized.';
		public static readonly FEATURES_INITIALIZED_SUCCESSFULLY = 'Features initialized successfully.';
		public static readonly REQUEST_PUSH_NOT_POSSIBLE = `"requestPush" method cannot be invoked because application triggered push could not be enabled! 
        You might need to provide the "surveyInvitationDialogCallback" to "initializeFeedback" method to use App Push, Instant Push and Timed Push features.
		Other possibility could be that, the PX Configuration validation might not be successful. Please check the configuration further or you could open a internal ticket (component "CA-PX-API").`;
		public static readonly PUSH_DATA_NOT_VALID = 'pushData is not provided!';
		public static readonly REQUEST_PUSH_APP_PUSH_OPTED_OUT = 'requestPush cannot be triggered since appPush has been Opted out.';
		public static readonly REQUEST_PUSH_INSTANT_PUSH_OPTED_OUT = 'requestPush cannot be triggered since instantPush has been Opted out.';
		public static readonly REQUEST_PUSH_DAILY_LIMIT_REACHED = 'requestPush cannot be triggered since instantPush has reached its daily limit.';
		public static readonly LOADED_QSI_API_UNLOADED =
			'Loaded QSI.API instance found, will be unloaded. Running two instances in parallel not possible.';
		public static readonly CFG_NO_SCOPE_ITEM_FOUND = 'No Scope Set item defined. Further initialization aborted as not necessary.';
		public static readonly CFG_NO_MANUAL_SCOPE_SET = 'Scope Set item "manual" is required in order to use User-initiated feedback.';
		public static readonly RUNTIME_CFG_UNDEFINED = '"requestPush" is not possible because runtime configuration is undefined.';
		public static readonly API_ALREADY_INITIALIZED =
			'PX-API already initialized. If initialization with different configuration required, create new instance or call "destroy" first.';
	};
	public static RECURRING_TRIGGER = class {
		public static readonly CTOR_INTERVAL_NOT_VALID_NUMBER = 'Interval is not a valid number: ';
		public static readonly CTOR_MAX_LIMIT_NOT_VALID_NUMBER = 'Max Limit is not a valid number: ';
		public static readonly CTOR_START_THRESHOLD_NOT_VALID_NUMBER = 'Start Threshold is not a valid number: ';
	};
	public static THEME_VALUE_FETCHER = class {
		public static readonly LOAD_KEY_MAP_ERROR = 'Something went wrong when trying to load the theming key map';
	};

	public static VALIDATION_HANDLER = class {
		public static readonly CTOR_PARAM_STORAGE_NOT_PROVIDED = 'storage is not provided!';
		public static readonly CTOR_PARAM_CENTRAL_CFG_NOT_PROVIDED = 'centralConfig is not provided!';
	};

	public static PUSH_CONTEXT_DATA = class {
		public static readonly INVALID_PAYLOAD = 'Invalid payload provided in PushFeedbackRequestData!.';
	};
}
